/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useAuthModalRootStore, type TAuthModalRootTypes } from './auth-modal-root.store';
import { OTPModal } from '../otp-modal';
import SignOutModal from '../signout-modal/sign-out-modal';
import CredentialModal from '../credential-modal';

const modalMap: Partial<Record<TAuthModalRootTypes, React.ComponentType<any>>> = {
  OTPModal,
  SignOutModal,
  CredentialModal,
};

const AuthModalRoot = memo(() => {
  // HOOKS
  const { modals } = useAuthModalRootStore();

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];

        if (!ModalComponent) return null;

        return <ModalComponent key={idx} {...props} />;
      })}
    </>
  );
});
AuthModalRoot.displayName = 'AuthModalRoot';

export default AuthModalRoot;
